import type {
  GatewayInstance,
  ServerDetails,
  ServerRegion,
} from '@/services/business/servers';
import { serverRegions } from '@/services/business/servers/types';

// Synthetic addresses from TEST-NET; one module-lifetime baseline for all snapshots.
const baseline = Date.now();
const ago = (minutes: number) => new Date(baseline - minutes * 60_000).toISOString();
const instanceSeeds: Pick<GatewayInstance, 'id' | 'serverId' | 'status'>[] = [
  { id: 'gateway-sh-01', serverId: 'srv-sh-01', status: 'ready' },
  { id: 'gateway-sh-02', serverId: 'srv-sh-01', status: 'ready' },
  { id: 'gateway-bj-01', serverId: 'srv-bj-01', status: 'ready' },
  { id: 'gateway-bj-02', serverId: 'srv-bj-01', status: 'draining' },
  { id: 'gateway-gz-01', serverId: 'srv-gz-01', status: 'offline' },
];
export const gatewayInstances: GatewayInstance[] = instanceSeeds.map(
  (instance, index) => ({
    ...instance,
    desiredVersion: 'v1.8.2',
    appliedVersion: instance.status === 'ready' ? 'v1.8.2' : 'v1.8.1',
    inflightRequests:
      instance.status === 'offline'
        ? null
        : instance.status === 'draining'
          ? 8
          : index * 3,
    lastHeartbeatAt: ago(instance.status === 'offline' ? 90 : 1),
  }),
);
export const gatewayServers: ServerDetails[] = Array.from(
  { length: 12 },
  (_, index) => {
    const region: ServerRegion = serverRegions[index % 3];
    // Preserve existing foreign keys while replacing the fixture geography.
    const legacyRegion = (['sh', 'bj', 'gz'] as const)[index % 3];
    const number = Math.floor(index / 3) + 1;
    const id = `srv-${legacyRegion}-${String(number).padStart(2, '0')}`;
    const status =
      index === 2 || index === 8 ? 'offline' : index === 11 ? 'unknown' : 'online';
    const instances = gatewayInstances.filter((instance) => instance.serverId === id);
    const sampledAt = status === 'unknown' ? null : ago(status === 'offline' ? 90 : 1);
    return {
      id,
      name: `gateway-host-${region}-${String(number).padStart(2, '0')}`,
      clusterId: 'cluster-primary',
      region,
      ip: `192.0.2.${index + 10}`,
      status,
      cpu: status === 'unknown' ? null : 18 + index * 6,
      memory: status === 'unknown' ? null : 25 + index * 4,
      disk: status === 'unknown' ? null : 32 + index * 3,
      sampledAt,
      lastReportedAt: sampledAt,
      specification: '8 vCPU / 16 GiB',
      instanceCount: instances.length,
      readyCount: instances.filter((instance) => instance.status === 'ready').length,
      instances,
    };
  },
);
